














import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class IdCard extends Vue {
    @Prop(String) readonly displayName: string | undefined;
    @Prop(String) readonly photo: string | undefined;
    @Prop({default: []}) readonly tags: string[] | undefined;
}

